import { useState } from "react";
import { fetchDownloadUrl } from "../actions/datasetAction";
import { useAppDispatch } from "../store/store";

const useDownloadButton = (datasetId: string,record: any, indexRow: any, path?:string) => {
  const dispatch = useAppDispatch();
  const [currentkey, setCurrentKey] = useState("");

  const fetchUrl = async (id: string, name: string, prefix?:string) => {
    return await dispatch(fetchDownloadUrl(id, name, prefix)).then((result: string) => {
      return result;
    });
  };

  const handleOnClick = async (prefix?:string) => {
    setCurrentKey(record.key);
    /****** Download Url********/
    const url = await fetchUrl(datasetId,record.name, prefix);
    /**************************/
    if (url) {
      window.location=url;
      setCurrentKey("");
    }
  };
  return { handleOnClick, currentkey };
};
export default useDownloadButton;
